import { Button, ButtonProps, Modal, ModalVariant } from '@patternfly/react-core';
import React, { FC, ReactNode } from 'react';

type Props = {
  onModalConfirm: () => void;
  onModalCancel?: () => void;
  isOpen?: boolean;
  title?: string;
  body?: string;
  confirmText?: string | ReactNode;
  cancelText?: string;
  confirmVariant?: ButtonProps['variant'];
  disableConfirm?: boolean;
};

export const ConfirmationDialog: FC<Props> = ({
  onModalConfirm,
  onModalCancel = () => {
    return;
  },
  isOpen = false,
  title = 'Confirm this action',
  body = 'Confirm the following action.',
  confirmText = 'Confirm',
  confirmVariant = 'primary',
  disableConfirm = false,
  cancelText = 'Cancel',
}) => {
  const handleModalConfirm = () => {
    onModalConfirm();
  };

  const handleModalCancel = () => {
    onModalCancel();
  };

  return (
    <Modal
      variant={ModalVariant.small}
      title={title}
      isOpen={isOpen}
      onClose={handleModalCancel}
      actions={[
        <Button key="confirm" variant={confirmVariant} onClick={handleModalConfirm} isDisabled={disableConfirm}>
          {confirmText}
        </Button>,
        <Button key="cancel" variant="link" onClick={handleModalCancel}>
          {cancelText}
        </Button>,
      ]}
    >
      {body}
    </Modal>
  );
};
